import { render, staticRenderFns } from "./fournisseur_edit.vue?vue&type=template&id=b6e14f44&scoped=true&"
import script from "./fournisseur_edit.vue?vue&type=script&lang=js&"
export * from "./fournisseur_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e14f44",
  null
  
)

export default component.exports